import React from 'react';
import 'reflect-metadata';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './app/store'
import { App } from './app';
import { Auth0ProviderWithNavigate } from './features/authentication/auth0-provider-with-navigate';
import './app.css';

const container = document.getElementById('root') as HTMLElement;

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <div className="h-lvh w-screen bg-abstract bg-cover overflow-x-hidden">
        <BrowserRouter>
          <Auth0ProviderWithNavigate>
            <App />
          </Auth0ProviderWithNavigate>
        </BrowserRouter>
      </div>
    </Provider >
  </React.StrictMode>
);